// src/generator/LogBar/MediumWidthLogBar/MediumWidthLogbar.tsx
import { Divider, Flex, Text } from "@mantine/core";
import DraftAutoSaveModal from "src/components/shared/_Modals/DraftAutoSaveModal/DraftAutoSaveModal";
import { BackButton } from "src/components/shared/BackButton/BackButton";
import { useIsExpired } from "src/generator/hooks/useIsExpired";
import { useIsNewEntry } from "src/hooks";
import { useSelector } from "src/redux/hooks";

import { ReadonlyFieldset } from "../../Logbook/Logbook.styled";
import NewEntryButton from "../_Buttons/NewEntryButton";
import ReopenNMEAModalButton from "../_Buttons/ReopenNMEAModalButton";
import SaveEntryButton from "../_Buttons/SaveEntryButton";
import SearchButton from "../_Buttons/SearchButton";
import SearchRefInput from "../_Buttons/SearchRefInput";
import SortEntriesButton from "../_Buttons/SortEntriesButton";
import GlobalCollapseButton from "../../../components/shared/GlobalCollapseButton/GlobalCollapseButton";
import EntryLockInfo from "../EntryLockInfo/EntryLockInfo";
import EntryText from "../EntryText";
import HamburgerMenu from "../HamburgerMenu/HamburgerMenu";
import LogBarSelects from "../LogBarSelects/LogBarSelects";
import StatusBadge from "../StatusBadge/StatusBadge";

const MediumWidthLogbar = () => {
  const { latestEntry, lbentry } = useSelector(state => state.generatorSlice);
  const isNewEntry = useIsNewEntry();
  const isExpiredLogbook = useIsExpired();
  const isReadOnly = useSelector(
    state => state.generatorSlice.lbentry.isReadonly,
  );

  return (
    <>
      <Flex
        justify="space-between"
        m={0}
        mih="58px"
        align="center"
        wrap="wrap"
        gap="20px"
        mb={15}>
        <Flex direction="column">
          <Flex align="center" gap="10px" mb={5}>
            <BackButton />
            <Text
              ml={15}
              mr={5}
              maw={450}
              data-cy="lbname"
              style={{ textTransform: "capitalize" }}>
              {latestEntry.lbName}
            </Text>
            {latestEntry.entryref && (
              <Text maw={400} data-cy="lbentryref">
                Entry Ref. #{latestEntry.entryref}
              </Text>
            )}
            <SearchRefInput />
            <StatusBadge
              status={isNewEntry ? "new" : latestEntry.status}
              autosave={latestEntry.autosave}
            />
            <EntryLockInfo />
          </Flex>
          <EntryText />
          <div style={{ maxWidth: "450px" }}>
            <DraftAutoSaveModal />
          </div>
        </Flex>

        <Flex justify="flex-end" align="center" style={{ flex: 1 }}>
          <GlobalCollapseButton />
          <SortEntriesButton />
          <ReopenNMEAModalButton />
          <ReadonlyFieldset disabled={isReadOnly}>
            {!isExpiredLogbook && <SaveEntryButton />}
            {!isExpiredLogbook && !lbentry.continousEntry && <NewEntryButton />}
          </ReadonlyFieldset>
          <HamburgerMenu />
          <SearchButton />
        </Flex>
      </Flex>

      <LogBarSelects gap={50} mr={-40} />
      <Divider my="sm" />
    </>
  );
};

export default MediumWidthLogbar;
